import { useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { useSOS } from "@/hooks/useSOS";
import { SOSButton } from "./SOSButton";
import { SOSChat } from "./SOSChat";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export function GlobalSOS() {
  const sos = useSOS();
  const { pathname } = useLocation();
  const [session, setSession] = useState<any>(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  // Hide on auth/onboarding where it might interfere, or if not logged in
  // Also hide on public pages like index, reset password, privacy, terms.
  if (
    !session || 
    pathname === "/" || 
    pathname === "/auth" || 
    pathname.startsWith("/onboarding") ||
    ["/reset-password", "/privacy", "/terms"].includes(pathname)
  ) {
    return null;
  }

  // Hide inline SOSButton if we are on Dashboard to avoid seeing two if we keep the one in Dashboard's header
  // Alternatively, we just float it on ALL pages at bottom right.
  const isDashboard = pathname === "/dashboard";

  return (
    <>
    <div className="fixed top-3 left-1/2 translate-x-[6px] z-[55]">
      <div className="shadow-lg rounded-full overflow-hidden bg-background scale-90">
        <SOSButton 
          onTrigger={() => sos.triggerSOS("manual")} 
          isActive={!!sos.activeAlert} 
        />
      </div>
    </div>

      <AnimatePresence>
        {sos.activeAlert && (
          <SOSChat
            messages={sos.chatMessages}
            isStreaming={sos.isStreaming}
            onSend={sos.sendMessage}
            onResolve={sos.resolveAlert}
          />
        )}
      </AnimatePresence>
    </>
  );
}
